class UomVariantPricing extends HTMLElement {
    constructor() {
        super();
    }

    showHideList(event) {
        event.preventDefault();
        this.section.classList.toggle('hidden');
    }

    setActive(event) {
        event.target.parentElement.querySelectorAll('.active').forEach(child => child.classList.remove('active'));
        event.target.classList.add('active');
        this.section.classList.add('hidden');
    }

    formatterPrice(currency = 'USD') {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency,
            maximumFractionDigits: 2
        })
    }

    updateProductPagePrice() {
        // created this because qty breaks and tax computation are conflicting in product page
        // this only works for product page

        const isProductPage = !this.closest('.card-product') && !!this.closest('.product-info')
        if (isProductPage) {
            const wrapperElm = this.closest('.product-info')

            const defaultVariant = wrapperElm.querySelector('.default-variant-id')
            const variantIdFromForm = wrapperElm.querySelector('form [name="id"]')?.value
            let selectedVariant = wrapperElm.querySelector('.selected-variant-id') || defaultVariant || variantIdFromForm

            // volume pricelist
            const volumePricelist = wrapperElm.querySelectorAll('.volume-pricelist [data-variant="' + selectedVariant + '"]')

            if (volumePricelist.length > 0) {
                const quantity = wrapperElm.querySelector('.quantity-label-field-input')?.dataset.value

                const activePricebreak = Array.from(volumePricelist)
                  .sort((a, b) => +b.dataset.quantityBreak - +a.dataset.quantityBreak)
                  .find(element => +element.dataset.quantityBreak <= +quantity)

                if (activePricebreak) {
                    const breakPrice = activePricebreak.dataset.breakPrice
                    const taxedPrice = computePriceWithTax(breakPrice * this.getUom())

                    wrapperElm.querySelector('.price-item:not(s)').innerHTML = this.formatterPrice().format(taxedPrice)
                }
            } else {
                // other elements to get price from
                const variantComparePrice = wrapperElm.querySelector(`[data-price-comparison="${selectedVariant}"]`)

                let price = null
                if (variantComparePrice) {
                    price = variantComparePrice.getAttribute('data-price-now')
                } else {
                    price = wrapperElm.querySelector('.price[data-price]')?.getAttribute('data-price') || null
                }

                if (!!price) {

                    price = parseFloat(`${[price]}`.replace(/[^0-9.]/g, ""));
                    const taxedPrice = computePriceWithTax(+price * this.getUom())

                    setTimeout(() => {
                        wrapperElm.querySelector('.price-item:not(s)').innerHTML = this.formatterPrice().format(taxedPrice)
                    }, 100)
                }
            }

        }
    }

    updatePrice(price, onSale = false) {
        const isProductPage = !this.closest('.card-product') && !!this.closest('.product-info')
        if (isProductPage) {
            // overide computation for product page
            this.updateProductPagePrice()
            return
        }
        
        const wrapperElm = this.closest('.card-product') || this.closest('.product-info')
        const priceClass = '.price-item-sale:not(s), .price-item-regular:not(s)';
        let priceElement = wrapperElm.querySelectorAll(priceClass)
        if (priceElement.length > 0) {
            const unchangedPrice = +price
            price = computePriceWithTax(price)
            priceElement.forEach( element => {
                if (!!element && !!price) {
                    element.innerHTML = this.formatterPrice().format(price)
                }
            })
        }

        setTimeout(() => {
            const selectedVariant = wrapperElm.querySelector('.selected-variant-id')
            if (selectedVariant) {
                let variantId = selectedVariant.value || null;

                if (variantId) {
                    const variantComparePrice = wrapperElm.querySelector(`[data-price-comparison="${variantId}"]`)
                    const hideComparePriceContainer = (hide = true) => {
                        wrapperElm.querySelectorAll('.compare-price-container').forEach(element => {
                            element.style.display = hide ? 'none' : 'block'
                        })
                    }

                    if (variantComparePrice) {
                        const comparePrice = +variantComparePrice.getAttribute('data-price-to-compare')
                        const priceNow = +variantComparePrice.getAttribute('data-price-now')

                        if (+comparePrice !== +priceNow) {

                            wrapperElm.querySelectorAll('[data-compare-price]').forEach(element => {
                                element.setAttribute('data-compare-price', comparePrice)
    
                                const quantity = +wrapperElm.querySelector('.quantity-label-field-input')?.dataset.value
                                const newComparePrice = comparePrice * quantity
                                
                                element.innerHTML = this.formatterPrice().format(computePriceWithTax(newComparePrice))
    
                            })
                            
                            hideComparePriceContainer(false)
                        } else {
                            hideComparePriceContainer(true)
                        }
                    } else {
                        hideComparePriceContainer(true)
                    }
                }
            }
        }, 50)

    }

    getQuantity() {
        const isProductPage = !this.closest('.card-product') && !!this.closest('.product-info')
        if (isProductPage) {
            return 1
        }

        const customElement = this.parentNode.parentElement.parentElement.querySelector('.quantity-label')
        if (customElement) {
            const quantityField = customElement.querySelector('input')
            if (quantityField) {
                const value = parseInt(quantityField.value)
                return !isNaN(value) ? value : 1
            }
        }

        return 1
    }

    getUom() {
        const customElement = this.parentNode.parentElement.parentElement.querySelector('input.selected-uom')
        if (customElement) {
            const value = parseInt(customElement.dataset.multiplier)
            return !isNaN(value) ? value : 1
        }

        return 1
    }

    getPrice() {
        const wrapperElm = this.closest('.card-product') || this.closest('.product-info')
        const parentElement = wrapperElm

        if (parentElement) {
            // get seleted variant
            const defaultVariant = parentElement.querySelector('.default-variant-id')
            const selectedVariant = parentElement.querySelector('.selected-variant-id')
            const variantId = selectedVariant ? selectedVariant.value : (defaultVariant ? defaultVariant.value : false)

            if (variantId) {
                const priceElement = parentElement.querySelector(`variant-dropdown [data-value="${variantId}"]`)
                if (priceElement) {
                    const value = parseFloat(priceElement.dataset.price_without_currency)
                    return !isNaN(value) ? value : 1
                }
            }

            let priceElm = this.closest('form').querySelector('.price')
            if (priceElm) {
                return +priceElm.getAttribute('data-price')
            }
            
            priceElm = wrapperElm.querySelector(variantId ? `[data-price-comparison="${variantId}"]` : '[data-price-comparison]')
            if (priceElm) {
                return +priceElm.getAttribute('data-price-now')
            }
        }

        return 1
    }

    updateMultiplyPrice(price, onSale = false, multiplier = 1) {
        // add delay to make sure to get the updated quantity
        setTimeout(() => {
            const quantity = this.getQuantity()
            const volumePrice = this.getVolumePrice((parseInt(multiplier) * quantity), price)
            const updatedPrice = (parseInt(multiplier) * quantity) * parseFloat(volumePrice)
            this.updatePrice(updatedPrice, onSale)
        }, 200)
    }

    getVolumePrice(quantityCount, originalPrice) {
        let newPrice = +originalPrice
        const wrapperElm = this.closest('.card-product') || this.closest('.product-info')
        let form = this.closest("form")
        if (!form) {
            if (wrapperElm) {
                form = wrapperElm.querySelector("form")
            }
        }

        let volumePricelist =  wrapperElm.querySelector('.volume-pricelist')
        if (volumePricelist) {
            let defaultVariant = form.querySelector(".default-variant-id")?.getAttribute('value')
            let selectedVariant = form.querySelector(".selected-variant-id")?.getAttribute('value')

            if (wrapperElm) {
                if (!defaultVariant) {
                    defaultVariant = wrapperElm.querySelector('.default-variant-id')?.getAttribute('value')
                }
                if (!selectedVariant) {
                    selectedVariant = wrapperElm.querySelector(".selected-variant-id")?.getAttribute('value') || defaultVariant
                }
            }

            if (!defaultVariant && !selectedVariant) {
                // force get variant from qty breaks
                const defaultVariantElm = wrapperElm.querySelector('.volume-pricelist [data-variant]')
                if (defaultVariantElm) {
                    defaultVariant = defaultVariantElm.getAttribute('data-variant')
                    selectedVariant = defaultVariantElm.getAttribute('data-variant')
                }
            }

            // get current variant to check
            const variantId = selectedVariant !== '' ? selectedVariant : defaultVariant

            // find the volume pricing for the selected variant
            let volumePricings = volumePricelist.querySelectorAll(`[data-variant="${variantId}"]`).length > 0 
                ? volumePricelist.querySelectorAll(`[data-variant="${variantId}"]`)
                : wrapperElm.querySelectorAll(`[data-variant="${variantId}"]`)

            // find valid qty Break
            let validQtyBreak = Array.from(volumePricings)
                .sort((a, b) => +b.dataset.quantityBreak - +a.dataset.quantityBreak)
                .find(qtyBreak => +quantityCount >= +qtyBreak.dataset.quantityBreak);

            if (validQtyBreak) {
                let breakPrice = +validQtyBreak.dataset.breakPrice
                newPrice = +validQtyBreak.dataset.breakPrice
                
                let parentElement = form.closest('.card-product') || form.closest('.product-info')
                if (parentElement) {
                    parentElement.querySelectorAll('[data-multiplier]').forEach(volumePrice => {
                        if (+volumePrice.getAttribute('data-multiplier') >= +validQtyBreak.dataset.quantityBreak) {
                            volumePrice.setAttribute('price', breakPrice)
                            volumePrice.setAttribute('data-price', breakPrice)
                        }
                    })
                }
            }
        }
        return newPrice
    }

    updateQuantityValue(multiplier = 1) {
        const customElement = this.parentNode.parentElement.parentElement.querySelector('.quantity-label')
        if (customElement) {
            const input = customElement.querySelector('input')
            const label = customElement.querySelector('.quantity-label-field')
            if (input && label) {
                const value = parseInt(label.dataset.value)
                input.value = value * multiplier
            }
        }
    }
}

if (!customElements.get('variant-dropdown')) {
    customElements.define('variant-dropdown', class VariantDropdown extends UomVariantPricing {
        constructor() {
            super();

            this.section = this.querySelector('div.card-product-variant-dropdown-select');
            this.input = this.querySelector('input');
            this.selected = this.querySelector('.selected-variant');
            this.variants = this.section.querySelectorAll('label.option-label');

            this.selected.addEventListener('click', this.showHideList.bind(this));

            this.variants.forEach((element) => {
                element.addEventListener('click', this.updateVariantId.bind(this));
            });
        }

        updateVariantId(event) {
            event.preventDefault();
            if (this.input) {
                this.input.value = event.target.dataset.value;
            }

            const price = event.target.dataset.price_without_currency

            this.selected.innerHTML = event.target.innerHTML;
            const comparePrice = event.target.dataset.compare_price
            const onSale = comparePrice !== ''

            this.setActive(event, this)
            this.updateBundlePrice(price, event.target.dataset.value)
            this.updateUomPrice(price)

            this.updateMultiplyPrice(price, onSale)

            // update regular price label on the card
            if (onSale) {
            this.updateMultiplyPrice(comparePrice)
            }

            const availability = this.availabilityHtml(event.target.dataset.availability, event.target.dataset.is_available)
            const badgeStock = this.parentNode.parentElement.parentElement.querySelector('.badge-stock')
            if (badgeStock) {
                if (availability?.divClass) {
                    badgeStock.className = availability.divClass;
                }
                if (availability?.message) {
                    badgeStock.innerHTML = availability.message;
                }
            }

        }

        availabilityHtml(message, isAvailable) {
            let divClass = 'badge-stock';
            if (isAvailable === 'true') {
                divClass += ' badge-stock-in'
            } else {
                divClass += ' badge-stock-out'
            }

            return {
                message: `<span class="badge-stock-dot"></span>${message}`,
                divClass
            }
        }

        updateBundlePrice (price, variantId) {
            const parentElm = this.parentNode.parentElement.parentElement
            parentElm.querySelectorAll('.bundle-price').forEach(bundle => {
                const multiplier = +bundle.dataset.multiplier

                // default pricing
                bundle.setAttribute('data-price', price)
                setTimeout(() => {
                    bundle.querySelector('.regular-unit-price').innerHTML =  this.formatterPrice().format(parseInt(multiplier) * parseFloat(price))
                }, 100)

                // get volume pricing
                parentElm.querySelectorAll(`[data-variant="${variantId}"]`).forEach(variantElm => {
                    const quantityBreak = +variantElm.dataset.quantityBreak
                    if (multiplier >= quantityBreak) {
                        bundle.setAttribute('data-price', +variantElm.dataset.breakPrice)
                        setTimeout(() => {
                            bundle.querySelector('.regular-unit-price').innerHTML =  this.formatterPrice().format(parseInt(multiplier) * parseFloat(+variantElm.dataset.breakPrice))
                        }, 100)

                    }
                })

            })
        }

        updateUomPrice (price) {
            const uom = this.closest('.card-product') ? this.closest('.card-product').querySelectorAll('.uom-dropdown-select label.option-label') : this.closest('.product-info').querySelectorAll('.uom-dropdown-select label.option-label')
            
            if (uom.length > 0) {
                uom.forEach(item => {
                    item.dataset.price = computePriceWithTax(price)
                    const multiplier = item.dataset.value
                    setTimeout(() => {
                        item.dataset.unit_price =  parseFloat(price)
                        item.dataset.price =   this.formatterPrice().format(parseInt(multiplier) * parseFloat(price))
                    }, 100)
                });
            }
        }
    });
}



if (!customElements.get('uom-dropdown')) {
    customElements.define('uom-dropdown', class UomDropdown extends UomVariantPricing {
        constructor() {
            super();
            this.section = this.querySelector('div.uom-dropdown-select');
            this.options = this.section.querySelectorAll('label.option-label');
            this.input = this.querySelector('input');
            this.selected = this.querySelector('label.selected-uom');
            this.quantity = this.parentNode.parentElement.parentElement.querySelector('.quantity-label-field')

            this.selected.addEventListener('click', this.showHideList.bind(this));
            this.options.forEach((element) => {
                element.addEventListener('click', this.updateUom.bind(this));
            });
            this.section.addEventListener('onBlur', function () {
                this.section.classList.add('hidden')
            })

        }

        updateUom(event) {
            event.preventDefault();
            const multiplier = event.target.dataset.value;
            const name = event.target.dataset.name;
            const unitPrice = event.target.dataset.unit_price
            const comparePrice = event.target.dataset.compare_price
            const onSale = comparePrice !== ''
            this.input.value = name;
            this.input.dataset.multiplier = multiplier;
            this.selected.innerHTML = name;
            this.setActive(event, this)
            this.updateQuantityValue(multiplier)
            this.updateMultiplyPrice(unitPrice, onSale)

            // update regular price label on the card
            if (onSale) {
                this.updateMultiplyPrice(comparePrice)
            }
        }
    });
}

if (!customElements.get('quantity-label')) {
    customElements.define('quantity-label', class UomDropdown extends UomVariantPricing {
        constructor() {
            super();
            this.section = this.querySelector('.quantity-label');
            this.input = this.section.querySelector('input');
            this.display = this.section.querySelector('.quantity-label-field');
            this.labels = this.section.querySelectorAll('label');
            this.labels.forEach((element) => {
                element.addEventListener('click', this.quantityCount.bind(this));
            });
        }

        quantityCount(event) {
            switch (event.target.dataset.type) {
                case 'input':
                    break;
                case 'plus':
                    this.stepUp()
                    break;
                case 'minus':
                    this.stepDown()
                    break;
            }
            this.updateMultiplyPrice(this.getPrice())
        }

        stepUp() {
            const multiplier = this.getUom()
            const inputValue = parseInt(this.input.value)
            const steps = (inputValue / multiplier)
            const value = steps + 1;
            this.updateQuantityElements(value, multiplier)
        }

        stepDown() {
            const multiplier = this.getUom()
            const inputValue = parseInt(this.input.value)
            const steps = (inputValue / multiplier)
            const value = steps > 1 ? steps - 1 : 1;
            this.updateQuantityElements(value, multiplier)
        }

        updateQuantityElements (value, multiplier) {
            this.input.value = value * multiplier
            this.display.innerHTML = value
            this.display.dataset.value = value
        }

    });
}

